import { useCallback, useEffect } from 'react'

import { useSelector } from 'react-redux'

import Tag from '@utils/Tag'
import { validaEnvHomeByBridge } from '@utils/functions'
import { ApplicationState } from '@store/types'

const TRACKING_LABEL = 'Serviço indisponível'

const sendUnavailableFeedbackTracking = (isApp: boolean) => {
  if (isApp) {
    Tag.enviarTagueamentoApp({
      screen: 'clt:refin:feedback',
      ref_type: '',
      content_action: 'Dado carregado',
      action_id: TRACKING_LABEL,
      section: 'feedback',
      sub_section: '',
      step: '',
      scenario: 'unavailable',
      ref_figma: '2',
    })
    return
  }

  Tag.enviarTagueamentoWeb({
    element_action: 'page_loaded',
    element_name: TRACKING_LABEL,
    c_page: window.location.href,
    redirect_url: '',
    section_name: 'payrollloan:refin:feedback',
    section: 'feedback',
    sub_section: '',
    step: '',
    scenario: 'unavailable',
  })
}

export const useServicoIndisponivelTracking = () => {
  const isApp = useSelector((state: ApplicationState) => state.ui.navigation.isApp)

  useEffect(() => {
    sendUnavailableFeedbackTracking(isApp)
  }, [isApp])
}

export const useEntendiRedirect = () => {
  const { origemGoBack, isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  return useCallback(() => {
    window.location.href = validaEnvHomeByBridge(String(origemGoBack), isApp) || ''
  }, [origemGoBack, isApp])
}
